import { render, staticRenderFns } from "./PhonenumberInput.vue?vue&type=template&id=7f483fb6"
import script from "./PhonenumberInput.vue?vue&type=script&lang=js"
export * from "./PhonenumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports